export default __webpack_public_path__ + "ibu_letter_header.0b0bc20.png";